import GoldenCrossChart from '../components/GoldenCrossChart'

const GoldenCross = () => {
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <GoldenCrossChart />
    </div>
  )
}

export default GoldenCross
